import { ModalContentProps } from "@chakra-ui/react";

interface IModalStyle {
  content: Partial<ModalContentProps>;
}

export const modalStyles: IModalStyle = {
  content: {
    position: {
      base: "fixed",
      md: "relative",
    },
    bottom: { base: "0px" },
    mb: "0",
    p: "4",
    borderRadius: {
      base: "1.75rem 1.75rem 0px 0px",
      md: "md",
    },
    maxW: { base: "2xl", lg: "5xl" },
  },
};
